import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/poppins';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider as ReduxProvider } from 'react-redux';
import { reducer } from './redux/store';
import MuiXLicense from './License/MuiXLicense';
import { mixpanelInit } from './mixPanelFunctions/mixPanelFunctions';

const root = ReactDOM.createRoot(document.getElementById('root'));
mixpanelInit()//mixpanel init function
root.render(
  <ReduxProvider store={reducer}>
    <App />
    <MuiXLicense />
  </ReduxProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
